/**
 * Responsive CSS for Header prebuilt blocks.
 * Injected into generated email HTML so layouts stack on narrow viewports.
 */
export const HEADER_RESPONSIVE_CSS = `
  @media only screen and (max-width: 768px) {
    .header-block-wrap {
      padding: 16px !important;
    }

    /* Stack logo / nav / CTA sections (desktop horizontal layouts only) */
    .header-modern-clean-table,
    .header-modern-clean-table > tbody,
    .header-modern-clean-table > tbody > tr,
    .header-action-table,
    .header-action-table > tbody,
    .header-action-table > tbody > tr {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
    }
    .header-modern-clean-logo,
    .header-modern-clean-nav,
    .header-action-logo,
    .header-action-nav,
    .header-action-cta {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      text-align: center !important;
      box-sizing: border-box !important;
    }
    .header-modern-clean-logo,
    .header-action-logo {
      padding-bottom: 12px !important;
    }
    .header-modern-clean-logo img,
    .header-action-logo img,
    .header-mobile-logo img {
      display: block !important;
      margin: 0 auto !important;
    }
    .header-modern-clean-nav,
    .header-action-nav {
      padding: 8px 0 !important;
    }
    .header-action-cta {
      padding-top: 12px !important;
    }

    /* Mobile preview stack: only outer rows block; keep nav links in one row */
    .header-mobile-stack > tbody > tr {
      display: block !important;
      width: 100% !important;
    }
    .header-mobile-stack > tbody > tr > td {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      text-align: center !important;
      box-sizing: border-box !important;
    }

    /* Horizontal nav row (matches builder flex row) */
    .header-nav-row-table {
      width: auto !important;
      max-width: 100% !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }
    .header-nav-row-table tr.header-nav-row {
      display: table-row !important;
    }
    .header-nav-row-table td.header-nav-cell {
      display: table-cell !important;
      width: auto !important;
      padding: 6px 10px !important;
      text-align: center !important;
      vertical-align: middle !important;
    }
    .header-nav-link {
      font-size: 13px !important;
      white-space: nowrap !important;
    }

    .header-centered-wrap {
      padding: 24px 16px !important;
    }
    .header-centered-logo-cell {
      padding-bottom: 16px !important;
    }
    .header-action-btn {
      display: inline-block !important;
      margin: 0 auto !important;
    }
  }
`;

/** Mobile spacing / typography for builder canvas (BlockRenderer). */
export const headerMobile = {
  padding: '16px',
  centeredPadding: '24px 16px',
  logoMaxWidthScale: 0.85,
  navGap: '20px',
  navFontSize: '13px',
  actionBtnPadding: '10px 18px',
} as const;

/** Pick readable nav color from background when user has not set navTextColor. */
export const resolveHeaderNavColor = (
  backgroundColor: string | undefined,
  navTextColor: string | undefined,
  layout: string
): string => {
  if (navTextColor && navTextColor.trim()) return navTextColor.trim();
  if (layout === 'modern-clean') return '#F8FAFC';
  return '#1E293B';
};

export const resolveHeaderAccentColor = (layout: string, index: number, accentColor?: string): string | null => {
  if (layout === 'dark-accent' && index === 0) {
    return accentColor || '#CA8A04';
  }
  return null;
};
